import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import AssignSOPage from 'pages/pick/assign-task/AssignTaskPage';
import PickItemPage from 'pages/pick/pick-item/PickItemPage';
import { PickSummaryPage } from 'pages/pick/pick-summary';
import PickingListPage from 'pages/pick/picking-list/PickingListPage';

import {
  PICK_TASK_ROUTE_ROOT,
  PICK_TASK_ROUTES,
} from './constants/pick-task-routes.constant';

export const usePickTaskRouter = (): React.JSX.Element => (
  <Route
    path={PICK_TASK_ROUTE_ROOT}
    element={
      <PrivateRoute
        roles={[
          UserRolesEnum.SUPER_ADMIN,
          UserRolesEnum.ADMIN,
          UserRolesEnum.PICKER,
          UserRolesEnum.PICKER_LEAD,
        ]}
      />
    }
  >
    <Route path={PICK_TASK_ROUTES.ASSIGN} element={<AssignSOPage />} />
    <Route path={PICK_TASK_ROUTES.LIST} element={<PickingListPage />} />
    <Route path={PICK_TASK_ROUTES.ITEM} element={<PickItemPage />} />
    <Route path={PICK_TASK_ROUTES.SUMMARY} element={<PickSummaryPage />} />
    <Route
      path={PICK_TASK_ROUTES.PICK_TASK}
      element={<Navigate to={PICK_TASK_ROUTES.ASSIGN} />}
    />
  </Route>
);
